import type { FC } from 'react';

import type { IllustrationProps } from './types';

export const SuccessTick: FC<IllustrationProps> = ({
  height = 128,
  width = 128,
}) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.7126 45.5576C69.7126 49.1852 66.7719 52.1259 63.1443 52.1259C59.5167 52.1259 56.5759 49.1852 56.5759 45.5576C56.5759 41.93 59.5167 38.9893 63.1443 38.9893C66.7719 38.9893 69.7126 41.93 69.7126 45.5576ZM63.1443 43.3405C61.9198 43.3405 60.9272 44.3331 60.9272 45.5576C60.9272 46.782 61.9198 47.7747 63.1443 47.7747C64.3687 47.7747 65.3613 46.782 65.3613 45.5576C65.3613 44.3331 64.3687 43.3405 63.1443 43.3405Z"
      fill="#FDC221"
    />
    <path
      d="M38.6694 35.6616C38.6694 39.3132 35.7092 42.2734 32.0576 42.2734C28.406 42.2734 25.4458 39.3132 25.4458 35.6616C25.4458 32.01 28.406 29.0498 32.0576 29.0498C35.7092 29.0498 38.6694 32.01 38.6694 35.6616ZM32.0576 33.4299C30.8251 33.4299 29.8259 34.4291 29.8259 35.6616C29.8259 36.8942 30.8251 37.8934 32.0576 37.8934C33.2902 37.8934 34.2894 36.8942 34.2894 35.6616C34.2894 34.4291 33.2902 33.4299 32.0576 33.4299Z"
      fill="#56D3DF"
    />
    <path
      d="M50.0075 48.8418C44.5661 48.8418 40.155 53.2529 40.155 58.6943H50.0075V48.8418Z"
      fill="#6E56E6"
    />
    <path
      d="M92.7017 25.8525C98.1431 25.8525 102.554 30.2636 102.554 35.705H92.7017V25.8525Z"
      fill="#FDC221"
    />
    <path
      d="M80.5271 25.8526L73.5603 32.8193L75.8826 35.1416L82.8493 28.1748L80.5271 25.8526Z"
      fill="#56D3DF"
    />
    <path
      d="M94.3431 42.313H91.059C91.059 44.4555 89.6771 46.2771 87.76 46.9463V45.5895C87.76 42.8775 85.5538 40.6709 82.8413 40.6709C80.1297 40.6709 77.9231 42.8775 77.9231 45.5895C77.9231 48.3016 80.1297 50.5078 82.8413 50.5078H84.1843C83.5044 52.4049 81.6931 53.7683 79.5652 53.7683V57.0524C83.5669 57.0524 86.9024 54.1672 87.6144 50.369C91.4346 49.675 94.3431 46.3304 94.3431 42.313ZM81.2073 45.5895C81.2073 44.6883 81.9401 43.9551 82.8413 43.9551C83.7425 43.9551 84.4758 44.6883 84.4758 45.5895V47.2236H82.8413C81.9401 47.2236 81.2073 46.4908 81.2073 45.5895Z"
      fill="#6E56E6"
    />
    <path
      d="M54.9338 22.5612C54.9338 19.8491 52.7272 17.6426 50.0155 17.6426C47.3031 17.6426 45.0969 19.8491 45.0969 22.5612V23.9039C43.1999 23.2239 41.8364 21.4128 41.8364 19.2847H38.5522C38.5522 23.2863 41.4375 26.6219 45.2356 27.3338C45.9296 31.1542 49.2743 34.0626 53.2917 34.0626V30.7784C51.1493 30.7784 49.3276 29.3968 48.6585 27.4794H50.0156C52.7272 27.4794 54.9338 25.2733 54.9338 22.5612ZM48.3811 22.5612C48.3811 21.66 49.1143 20.9267 50.0156 20.9267C50.9168 20.9267 51.6496 21.66 51.6496 22.5612C51.6496 23.4624 50.9168 24.1953 50.0156 24.1953H48.3811V22.5612Z"
      fill="#EE399E"
    />
    <path
      d="M69.7126 65.2627C71.5264 65.2627 72.9968 63.7923 72.9968 61.9785C72.9968 60.1647 71.5264 58.6943 69.7126 58.6943C67.8988 58.6943 66.4285 60.1647 66.4285 61.9785C66.4285 63.7923 67.8988 65.2627 69.7126 65.2627Z"
      fill="#F470BD"
    />
    <path
      d="M69.7126 22.5683C71.5264 22.5683 72.9968 21.098 72.9968 19.2842C72.9968 17.4704 71.5264 16 69.7126 16C67.8988 16 66.4285 17.4704 66.4285 19.2842C66.4285 21.098 67.8988 22.5683 69.7126 22.5683Z"
      fill="#FDC221"
    />
    <path
      d="M58.8982 65.8262L56.5759 68.1484L63.5427 75.1152L65.8649 72.7929L58.8982 65.8262Z"
      fill="#56D3DF"
    />
    <path
      d="M62.0349 112C59.4218 112 56.9155 110.962 55.0683 109.114L38.4608 92.5055C34.613 88.6577 34.613 82.4196 38.4608 78.5718C42.3085 74.7252 48.5482 74.7257 52.3939 78.5724L62.0349 88.2139L87.1811 63.0687C91.0299 59.2221 97.2697 59.2215 101.114 63.0693C104.962 66.917 104.962 73.1552 101.114 77.0029L69.0015 109.115C67.1543 110.962 64.648 112 62.0349 112Z"
      fill="#EE399E"
    />
  </svg>
);
